import React, { useState } from 'react';
import './Servizi.css';
import WelfareBanner from '../../common/welfareBanner/WelfareBanner';
import heroImage from '../../../assets/images/servizi/hero-profile.jpg';
import { Link } from 'react-router-dom';
import { servicesData } from '../../data/servicesData';
import { Service } from '../../../types/service';
import { Button } from 'react-bootstrap';

const Servizi: React.FC = () => {
  return (
    <div className="servizi-container">
      {/* Hero Section */}
      <section className="servizi-hero-section">
        <div className="container">
          <div className="row align-items-center min-vh-80 py-5">
            <div className="col-lg-6">
              <div className="hero-content">
                <h1 className="hero-title display-3 fw-bold mb-4">
                  <span className="text-gradient-primary">Servizi offerti</span>
                </h1>
                <p className="hero-description lead text-muted mb-4">
                  DI PERSONA oppure ON LINE scopri i percorsi di "BenEssere su
                  misura" che propongo e scegli quello che fa per te!
                  <br />
                  Comincia da qui:
                  <br />
                  VALUTAZIONE POSTURALE
                  <br />
                  PERCORSO DI RIEQUILIBRIO POSTURALE CON PANCAFIT E CHAIR
                  <br />
                  PERSONAL TRAINING POSTURALE
                  <br />
                  PERSONAL YOGA
                </p>
                <div className="hero-actions d-flex gap-3 mb-4">
                  <Link
                    to="/rimettiti-al-centro"
                    className="btn btn-outline-secondary btn-lg px-4 py-2"
                  >
                    Scopri i miei videocorsi
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="servizi-hero-image position-relative">
                <div className="floating-element element-1 position-absolute"></div>
                <div className="floating-element element-2 position-absolute"></div>
                <div className="floating-element element-3 position-absolute"></div>
                <div className="main-image-placeholder text-center">
                  <img
                    src={heroImage}
                    alt="Annalisa - Formatrice di Benessere Posturale"
                    className="img-fluid rounded-circle shadow-lg"
                    style={{ maxWidth: '400px', border: '8px solid white' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Welfare Banner */}
      <section className="banner-section">
        <div className="container">
          <WelfareBanner />
        </div>
      </section>

      {/* Services Section */}
      <section className="services-page py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-xl-10">
              <div className="services-list d-flex flex-column gap-4 gap-md-5">
                {servicesData.map((service: Service, index: number) => (
                  <article
                    key={`service-${service.title}-${index}`}
                    className="service-section card border-0 shadow-sm overflow-hidden"
                  >
                    <div className="card-body p-3 p-md-4 p-lg-5">
                      <div className="service-header mb-4">
                        <div className="d-flex align-items-start gap-3 flex-column flex-sm-row">
                          <div className="service-emoji">{service.icon}</div>

                          <div className="flex-grow-1">
                            <h2 className="service-title h3 fw-bold mb-2">
                              {service.title}
                            </h2>

                            <p className="service-shortdesc lead mb-3">
                              {service.shortDesc}
                            </p>

                            {service.features &&
                              service.features?.length > 0 && (
                                <ul className="service-features list-unstyled mb-0">
                                  {service.features?.map((feature, i) => (
                                    <li
                                      key={i}
                                      className="d-flex align-items-start mb-2"
                                    >
                                      <i className="bi bi-check-circle-fill text-success me-2 mt-1"></i>
                                      <span>{feature}</span>
                                    </li>
                                  ))}
                                </ul>
                              )}
                          </div>
                        </div>
                      </div>

                      <div className="service-content">
                        {typeof service.longDesc === 'string' ? (
                          <p className="mb-0">{service.longDesc}</p>
                        ) : (
                          service.longDesc
                        )}
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Servizi;
